var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayAudioIcon = function SvgPlayAudioIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.36 11.83c.429-.234.95-.216 1.36.048l18.668 12a1.333 1.333 0 0 1 0 2.243l-18.667 12A1.333 1.333 0 0 1 15.666 37V13c0-.488.267-.937.695-1.17"
  })));
};
export default SvgPlayAudioIcon;